<div [formGroup]="form">
  <!-- Documento -->
  <div class="sub-section-container sub-secao-dados">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      <span>Documento</span>
    </div>

    <div class="row">
      <!-- Etapa (§9): só existe depois de gravado; documento novo nasce na etapa inicial do
           processo, decidida pelo servidor. -->
      @if (!ehNovo) {
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100" #campoEtapa>
            <mat-label>Etapa</mat-label>
            <mat-select #selectEtapa [formControl]="etapaControl" (selectionChange)="aoEscolherEtapa($event)"
              panelClass="vdd-etapa-painel">
              <!-- Fechado: a etapa atual, com o ícone e a cor do catálogo do Kanban. -->
              <mat-select-trigger>
                <span class="vdd-etapa-atual">
                  @if (iconeEtapa) {
                    <span class="vdd-etapa-icone" [style.background]="corEtapa?.fundo" [style.color]="corEtapa?.conteudo">
                      <mat-icon class="material-symbols-outlined">{{ iconeEtapa }}</mat-icon>
                    </span>
                  }
                  <span class="vdd-etapa-nome">{{ etapaAtual?.nome ?? '-' }}</span>
                </span>
              </mat-select-trigger>

              <!-- A etapa atual precisa existir como opção para o select considerá-la selecionada;
                   fica escondida porque quem lista é o "Mover para". -->
              @if (etapaAtual) {
                <mat-option [value]="etapaAtual.idEtapaKanban" class="vdd-etapa-opcao-atual">{{ etapaAtual.nome }}</mat-option>
              }

              <mat-optgroup label="Mover para">
                <!-- ng-container: o mat-optgroup só projeta como opção um `mat-option` ou `ng-container`
                     filho direto; o bloco @if/@for solto caía dentro do rótulo do grupo. -->
                <ng-container>
                @if (destinosDeEtapa.length) {
                  @for (d of destinosDeEtapa; track d.etapa.idEtapaKanban) {
                    <mat-option [value]="d.etapa.idEtapaKanban" class="vdd-etapa-opcao">
                      <span class="vdd-etapa-icone" [style.background]="d.cor.fundo" [style.color]="d.cor.conteudo">
                        @if (d.icone) {
                          <mat-icon class="material-symbols-outlined">{{ d.icone }}</mat-icon>
                        }
                      </span>
                      <span class="vdd-etapa-texto">
                        <span class="vdd-etapa-nome">{{ d.etapa.nome }}</span>
                        <span class="vdd-etapa-legenda">{{ d.legenda }}</span>
                      </span>
                    </mat-option>
                  }
                } @else {
                  <!-- §9: sem destino, a LISTA informa - o campo não fica mudo nem desabilitado. -->
                  <mat-option disabled class="vdd-etapa-vazio">
                    Não há etapa de destino habilitada a partir de {{ etapaAtual?.nome ?? 'esta etapa' }} na configuração do kanban.
                  </mat-option>
                }
                </ng-container>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>
      }

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número</mat-label>
          <input matInput formControlName="numero" [currencyMask]="mascaraInteira" inputmode="numeric"
            [readonly]="!isNumeroEditavel"
            [placeholder]="isNumeroEditavel ? 'Informe o número' : '(atribuído ao salvar)'">
          @if (!isNumeroEditavel) {
            <mat-icon matSuffix class="material-symbols-outlined icone-apoio"
              matTooltip="A numeração está como Sequencial: o número é atribuído ao salvar.">lock</mat-icon>
          }
          @if (isNumeroEditavel && form.get('numero')?.hasError('required')) {
            <mat-error>Informe o número do documento.</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ ehOrcamento ? 'Data do orçamento' : 'Data da venda' }}</mat-label>
          <input matInput [matDatepicker]="pickerEmissao" formControlName="dataEmissao"
            placeholder="DD/MM/AAAA" (input)="aoDigitarData($event, 'dataEmissao')">
          <mat-datepicker-toggle matSuffix [for]="pickerEmissao"></mat-datepicker-toggle>
          <mat-datepicker #pickerEmissao></mat-datepicker>
          @if (form.get('dataEmissao')?.hasError('required')) {
            <mat-error>Informe a data.</mat-error>
          }
        </mat-form-field>
      </div>

      @if (exibeNatureza) {
        <div class="col-12 col-md-6">
          <app-select-pesquisavel
            label="Natureza da operação"
            [control]="naturezaControl"
            [offlineList]="naturezas"
            idField="id"
            nameField="descricao"
            [disabled]="isSomenteLeitura"
            [hasSuffixAction]="true"
            [hasHintAction]="true"
            placeholder="Selecione...">

            <!-- Dentro da moldura, junto da seta: recarregar a lista é ação DO campo. -->
            <button spSuffix type="button" class="btn-redondo btn-spinner" [class.btn-loading]="isCarregandoNaturezas"
              [disabled]="isCarregandoNaturezas || isSomenteLeitura"
              (click)="recarregarNaturezas()"
              [attr.aria-label]="isCarregandoNaturezas ? 'Recarregando as naturezas' : 'Recarregar as naturezas do cadastro fiscal'"
              matTooltip="Recarregar as naturezas do cadastro fiscal">
              <mat-icon class="material-symbols-outlined">autorenew</mat-icon>
              @if (isCarregandoNaturezas) { <mat-spinner diameter="16"></mat-spinner> }
            </button>
            <!-- No hint do campo: com natureza abre o cadastro dela; sem, a listagem. -->
            <button spHint type="button" class="vdd-link-hint" (click)="abrirNaturezaOperacao()">Ir para a natureza da operação</button>
          </app-select-pesquisavel>
        </div>
      }

      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          label="Lista de preço"
          [control]="listaPrecoControl"
          [offlineList]="listasPreco"
          idField="id"
          nameField="descricao"
          [isOptional]="true"
          [disabled]="isSomenteLeitura"
          [hasSuffixAction]="true"
          (selectionChange)="aoTrocarListaPreco()"
          placeholder="Selecione...">

          <!-- Mesmo botão da natureza: a lista também é cadastrada em outra tela. -->
          <button spSuffix type="button" class="btn-redondo btn-spinner" [class.btn-loading]="isCarregandoListasPreco"
            [disabled]="isCarregandoListasPreco || isSomenteLeitura"
            (click)="recarregarListasPreco()"
            [attr.aria-label]="isCarregandoListasPreco ? 'Recarregando as listas de preço' : 'Recarregar as listas de preço do cadastro'"
            matTooltip="Recarregar as listas de preço do cadastro">
            <mat-icon class="material-symbols-outlined">autorenew</mat-icon>
            @if (isCarregandoListasPreco) { <mat-spinner diameter="16"></mat-spinner> }
          </button>
          <!-- Recalcular preços (§4.1, [ORC]): os itens voltam ao preço da lista vigente; o pedido não reprecifica (§12.5). -->
          @if (ehOrcamento) {
            <button spSuffix type="button" class="btn-redondo" [disabled]="isSomenteLeitura"
              (click)="recalcularPrecos.emit()"
              aria-label="Recalcular os preços dos itens pela lista vigente"
              matTooltip="Recalcular os preços dos itens pela lista vigente">
              <mat-icon class="material-symbols-outlined">currency_exchange</mat-icon>
            </button>
          }
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          label="Vendedor"
          [control]="vendedorControl"
          [offlineList]="vendedores"
          idField="idVendedor"
          nameField="nome"
          [isOptional]="!vendedorObrigatorio"
          [disabled]="isSomenteLeitura"
          [hint]="vendedores.length ? '' : 'Nenhum vendedor disponível no seu escopo.'"
          placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>

      @if (ehOrcamento) {
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Próximo contato</mat-label>
            <input matInput [matDatepicker]="pickerContato" formControlName="dataProximoContato"
              placeholder="DD/MM/AAAA" (input)="aoDigitarData($event, 'dataProximoContato')">
            <mat-datepicker-toggle matSuffix [for]="pickerContato"></mat-datepicker-toggle>
            <mat-datepicker #pickerContato></mat-datepicker>
          </mat-form-field>
        </div>
      }

      <!-- Nº do pedido do cliente e intermediador são do pedido: vão para a nota, o orçamento não usa. -->
      @if (!ehOrcamento) {
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nº do pedido do cliente</mat-label>
            <input matInput formControlName="numeroPedidoCliente" maxlength="60"
              placeholder="Nº no e-commerce ou da ordem de compra do cliente">
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <app-select-pesquisavel
            label="Intermediador da transação (NF-e)"
            [control]="indicadorIntermediadorControl"
            [offlineList]="indicadoresIntermediador"
            idField="id"
            nameField="descricao"
            [isOptional]="true"
            [disabled]="isSomenteLeitura"
            hint="Grupo infIntermed da nota - não é o intermediador de pagamento"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        </div>
      }

      @if (!ehOrcamento && isComIntermediador) {
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>CNPJ do intermediador</mat-label>
            <input matInput formControlName="cnpjIntermediador" [mask]="masks.cnpj">
            <mat-error>Informe o CNPJ do intermediador.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Identificador no intermediador</mat-label>
            <input matInput formControlName="identificadorIntermediador" maxlength="60">
            <mat-hint>Nome do usuário ou identificação do vendedor no site do intermediador</mat-hint>
            <mat-error>Informe o identificador no intermediador.</mat-error>
          </mat-form-field>
        </div>
      }

      @if (cadastradoEm) {
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Cadastrado em</mat-label>
            <input matInput [value]="cadastradoEm | date: 'dd/MM/yyyy HH:mm'" disabled>
          </mat-form-field>
        </div>
      }
    </div>
  </div>

  <!-- Prazos -->
  <div class="sub-section-container sub-secao-dados">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">event</mat-icon>
      <span>Prazos</span>
    </div>

    <div class="row">
      @if (ehOrcamento) {
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Validade (dias)</mat-label>
            <input matInput formControlName="validadeDias" [currencyMask]="mascaraInteira" inputmode="numeric"
              [readonly]="validadeBloqueada">
            @if (validadeBloqueada) {
              <mat-icon matSuffix class="material-symbols-outlined icone-apoio"
                matTooltip="O prazo vem da configuração do orçamento e não pode ser alterado aqui.">lock</mat-icon>
            }

            @if (form.get('validadeDias')?.hasError('required')) {
              <mat-error>Informe a validade da proposta.</mat-error>
            } @else if (dataValidadePrevista) {
              <mat-hint>Vence em {{ dataValidadePrevista | date: 'dd/MM/yyyy' }}</mat-hint>
            }
          </mat-form-field>
        </div>
      }

      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data prevista de entrega</mat-label>
          <input matInput [matDatepicker]="pickerPrevista" formControlName="dataPrevistaEntrega"
            placeholder="DD/MM/AAAA" (input)="aoDigitarData($event, 'dataPrevistaEntrega')">
          <mat-datepicker-toggle matSuffix [for]="pickerPrevista"></mat-datepicker-toggle>
          <mat-datepicker #pickerPrevista></mat-datepicker>
          <mat-hint>Impressa no documento</mat-hint>
        </mat-form-field>
      </div>

      @if (ehOrcamento) {
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descrição do prazo de entrega</mat-label>
            <input matInput formControlName="descricaoCondicoes" placeholder="Ex.: 15 dias úteis após a aprovação">
          </mat-form-field>
        </div>
      } @else {
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data de envio / despacho</mat-label>
            <input matInput [matDatepicker]="pickerEnvio" formControlName="dataEnvio"
              placeholder="DD/MM/AAAA" (input)="aoDigitarData($event, 'dataEnvio')">
            <mat-datepicker-toggle matSuffix [for]="pickerEnvio"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnvio></mat-datepicker>
            <mat-hint>Alimenta a expedição</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data máxima de despacho</mat-label>
            <input matInput [value]="(form.get('dataMaximaDespacho')?.value | date: 'dd/MM/yyyy') ?? ''" disabled>
            <mat-icon matSuffix class="material-symbols-outlined icone-apoio"
              matTooltip="Derivada pelo sistema; não é digitada aqui.">lock</mat-icon>
          </mat-form-field>
        </div>
      }
    </div>
  </div>

  <!-- Cliente -->
  <div class="sub-section-container sub-secao-dados">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">person</mat-icon>
      <span>Cliente</span>
    </div>

    <!-- Cliente em meia tela; na outra metade, "Aos cuidados de" e a escolha do endereço de entrega (PO, 23/10). -->
    <div class="row">
      <div class="col-12 col-md-6">
        <app-vd-cliente
          [control]="clienteControl"
          [clienteSelecionado]="clienteSelecionado"
          [bloqueiaPorAtraso]="bloqueiaClienteEmAtraso"
          [coresKanban]="coresKanban"
          [isSomenteLeitura]="isSomenteLeitura"
          [motivoClienteBloqueado]="motivoClienteBloqueado"
          (dadosFinanceiros)="clienteFinanceiro.emit($event)"
          (historicoCliente)="historicoCliente.emit($event)"
          (clienteAlterado)="clienteFinanceiro.emit(null); clienteEscolhido.emit($event)">
        </app-vd-cliente>
      </div>

      <div class="col-12 col-md-6">
        <!-- Aos cuidados de: pertence ao cliente e vale nos DOIS processos. -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Aos cuidados de</mat-label>
          <input matInput formControlName="aosCuidadosDe" placeholder="Nome da pessoa de contato">
        </mat-form-field>

        <!-- A escolha de entregar em outro endereço é do cliente; a subseção abaixo só existe com ela ligada. -->
        <div class="toggle-content">
          <mat-slide-toggle class="app-toggle-compact" formControlName="isEntregaEnderecoDiferente">
            Entregar em endereço diferente do cadastro do cliente
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <!-- Endereço de entrega -->
  @if (entregaEmOutroEndereco) {
    <div class="sub-section-container sub-secao-dados">
      <div class="sub-section-title">
        <mat-icon class="material-symbols-outlined">local_shipping</mat-icon>
        <span>Endereço de entrega</span>
      </div>

      <app-vd-endereco-entrega [form]="form" [isSomenteLeitura]="isSomenteLeitura">
      </app-vd-endereco-entrega>
    </div>
  }
</div>
